import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import { cx } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import { ViewTypes } from 'structure/multi-asset-staking/types';

interface IClaimActionsProps {
  view: string;
  handleView: (value: ViewTypes) => void;
}

export const ClaimActions = ({ handleView, view }: IClaimActionsProps) => {
  return (
    <div className='my-2 flex items-center justify-end'>
      <div className='flex items-center gap-2'>
        <Icon
          icon='apps'
          width='24'
          height='24'
          className={cx(
            'cursor-pointer',
            twMerge(
              view === ViewTypes.CARD_VIEW ? 'text-blue-500' : 'text-white'
            )
          )}
          onClick={() => handleView(ViewTypes.CARD_VIEW)}
        />
        <Icon
          icon='list_outline'
          width='24'
          height='24'
          className={twMerge(
            'cursor-pointer',
            cx(view === ViewTypes.LIST_VIEW ? 'text-blue-500' : 'text-white')
          )}
          onClick={() => handleView(ViewTypes.LIST_VIEW)}
        />
      </div>
    </div>
  );
};
